import _ from 'lodash';
import { GAME_ID, REDUX_ACTIONS } from '../../data/constants';

export const initialState = {
  introIsCompleted: false,
  selectedTile: null,
  selectedTiles: [],
  questions: [
  ],
  currentQuestion: {},
  questionsAnswered: 0,
  numQuestions: 0,
};

const practiceReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case REDUX_ACTIONS.INIT_ROUND:
      return {
        ...initialState,
      };
    case REDUX_ACTIONS.SELECT_PRACTICE_TILE:
      return {
        ...state,
        selectedTile: action.payload.selectedTile,
        selectedTiles: [
          ...state.selectedTiles,
          action.payload.selectedTile,
        ],
      };
    case REDUX_ACTIONS.RESET_PRACTICE_SELECTED_TILE:
      return {
        ...state,
        selectedTile: null,
      };
    case REDUX_ACTIONS.NEXT_PRACTICE_QUESTION:
      return {
        ...state,
        // eslint-disable-next-line you-dont-need-lodash-underscore/drop
        questions: _.drop(state.questions, 1),
        currentQuestion: _.head(state.questions),
        selectedTiles: [],
      };
    case REDUX_ACTIONS.ADD_PRACTICE_QUESTION:
      return {
        ...state,
        questions: [...state.questions, action.payload.question],
        numQuestions: state.numQuestions + 1,
      };
    case REDUX_ACTIONS.INCREMENT_PRACTICE_QUESTIONS_ANSWERED:
      return {
        ...state,
        questionsAnswered: state.questionsAnswered + 1,
      };
    case REDUX_ACTIONS.SET_PRACTICE_INTRO_COMPLETED:
      return {
        ...state,
        introIsCompleted: true,
      };
    default:
      return state;
  }
};

export default practiceReducer;
